(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('modalService', modalService);

    function modalService($uibModal, $q, loginService, $timeout) {
        var service = {
            login: login,
            forgetPwd: forgetPwd,
            register: register,
            getChoicePerSerilNo: getChoicePerSerilNo,
            getTaiClass: getTaiClass,
            getWindowClass: getWindowClass,
            isMobile: isMobile,
            isIos: isIos,
            touchWithMe: touchWithMe,
            explanation: explanation,
            setting: setting,
            courseDetail: courseDetail,
            editPwd: editPwd,
            phoneNumber: phoneNumber,
            trainingSelectAction: trainingSelectAction,
            selectActionConfirm: selectActionConfirm,
            confrimDialog: confrimDialog,
            openOptionSelector: openOptionSelector,
        };
        return service;
        //=================

        function isMobile() {
            // console.log("check isMobile");
            // console.log("window.orientation:", window.orientation);
            // console.log("navigator.userAgent.indexOf(\"IEMobile\"):", navigator.userAgent.indexOf("IEMobile"));
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf("IEMobile") !== -1);
        }

        function isIos() {
            return (navigator.userAgent.match(/ip(hone|ad|od)/i) && !navigator.userAgent.match(/(iemobile)[\/\s]?([\w\.]*)/i));
        }

        function getTaiClass() {
            if (service.isMobile()) {
                return 'mobile-modal-dialog,mobile-modal-content';
            }
        }

        function getWindowClass() {
            if (!service.isMobile()) {
                return 'modal-margin-top';
            }
        }

        function getChoicePerSerilNo(param) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/choicePerSerilNoModal.html',
                controller: 'choicePerSerilNoModalController as vm',
                size: 'sm',
                taiClass: getTaiClass(),
                resolve: {
                    data: function() {
                        return param;
                    }
                }
            });
            return modal;
        }

        function login() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/loginModal.html',
                controller: 'loginModalController as vm',
                size: 'sm',
                taiClass: getTaiClass()
            });
            modal.closed.then(onDestroy);

            return modal;
            //==
            function onDestroy() {
                var defer = $q.defer();
                var reCaptchaCheckChild = null;
                do {
                    if (reCaptchaCheckChild) {
                        //first round skip
                        var reCaptchaCheck = reCaptchaCheckChild.parentElement;
                        if (reCaptchaCheck && reCaptchaCheck.parentElement) {
                            reCaptchaCheck.parentElement.removeChild(reCaptchaCheck);
                        }
                    }
                    reCaptchaCheckChild = document.getElementsByClassName("g-recaptcha-bubble-arrow")[0];
                } while (reCaptchaCheckChild);

                defer.resolve('Success!');
                return defer.promise;
            }
        }

        function forgetPwd() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/forgetPwdModal.html',
                controller: 'forgetPwdModalController as vm',
                size: 'sm',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function register() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/registerModal.html',
                controller: 'registerModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function touchWithMe() {
            //20180315 Anthony 
            //在開啟這modal時，資料延遲有時間差，所以調整成先拿完資料再開啟

            //20180326 Anthony Add new variable for login/nonLogin
            var delaySec = 1;
            var userData = {
                cName: null,
                email: null,
                isLogin: false
            };

            if (sessionStorage.getItem('token')) {
                loginService.getSsoInfo().then(function(data) {
                    userData.cName = sessionStorage.getItem('cName');
                    userData.email = data.data.email;
                    userData.isLogin = true;
                });

                delaySec = 1500;
            }



            //sso 資料回傳有延遲，這裡延遲開啟modal
            $timeout(function() {
                var modal = $uibModal.open({
                    templateUrl: 'controller/common/modal/contectModal.html',
                    controller: 'contectModalController as vm',
                    size: 'sm',
                    taiClass: getTaiClass(),
                    resolve: {
                        userData: function() {
                            return userData;
                        }
                    }
                });
                return modal;
            }, delaySec);

        }

        function confrimDialog(config) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/confirmDialog/confirmDialog.html',
                controller: 'confirmDialogController as vm',
                size: 'md',
                taiClass: getTaiClass(),
                resolve: {
                    config: function() {
                        config = config || {};
                        var paramConfig = {
                            confirmTitle: config.confirmTitle || '',
                            confirmContent: config.confirmContent || '',
                            textButtonOk: config.textButtonOk || null,
                            textButtonCancel: config.textButtonCancel || null,
                            promiseAction: config.promiseAction
                        };
                        return paramConfig;
                    }
                }
            });
            return modal;
        }

        function explanation() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/explanationModal.html',
                controller: 'explanationModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function setting(param) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/settingModal.html',
                controller: 'settingModalController as vm',
                size: 'lg',
                taiClass: getTaiClass(),
                resolve: {
                    viewModel: function() {
                        return param;
                    }
                }
            });
            return modal;
        }

        function courseDetail(item, settingModel, defaultTabIndex) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/courseDetailModal.html',
                controller: 'courseDetailModalController as vm',
                size: 'lg',
                taiClass: getTaiClass(),
                resolve: {
                    courseItem: item,
                    settingModel: settingModel,
                    defaultTabIndex: defaultTabIndex
                }
            });

            modal.rendered.then(function() {

                var modalBootstrap = $(".modal-open > .modal");
                modalBootstrap.scroll(function() {
                    // 改變"回頂端"樣式，只有當下拉選單滾到一定層度才會出現
                    var modalContent = this;
                    var goTop = modalBootstrap.find("div.goTop a");
                    if (!goTop) { return; }
                    if (modalContent.scrollTop < 300) {
                        modalBootstrap.find("div.goTop a").css({ "position": "relative", "top": "0px", "display": "none" });
                    } else {
                        modalBootstrap.find("div.goTop a").css({ "position": "absolute", "top": modalContent.scrollTop, "display": "block" });
                    }
                });
            });
            return modal;
        }

        function editPwd() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/editPwdModal.html',
                controller: 'editPwdModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function phoneNumber() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/phoneNumberModal.html',
                controller: 'phoneNumberModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function trainingSelectAction(viewModel) {
            var modal = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingSelectActionModal.html',
                controller: 'myTrainingSelectActionModalController as vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                taiClass: getTaiClass(),
                resolve: {
                    viewModel: function() {
                        // console.log("trainingSelectAction  viewModel",viewModel);
                        return viewModel;
                    }
                }
            });

            modal.rendered.then(function() {

                var modalBootstrap = $(".modal-open > .modal");
                modalBootstrap.scroll(function() {
                    // 改變"回頂端"樣式，只有當下拉選單滾到一定層度才會出現
                    var modalContent = this;
                    var goTop = modalBootstrap.find("div.goTop a");
                    if (!goTop) { return; }
                    if (modalContent.scrollTop < 300) {
                        modalBootstrap.find("div.goTop a").css({ "position": "relative", "top": "0px", "display": "none" });
                    } else {
                        modalBootstrap.find("div.goTop a").css({ "position": "absolute", "top": modalContent.scrollTop, "display": "block" });
                    }
                });
            });
            return modal;
        }

        function selectActionConfirm(ctmsConfirmTime, param) {
            //console.log('ctmsConfirmTime:',ctmsConfirmTime);
            var modalResult = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingSelectActionConfirmModal.html',
                controller: 'myTrainingSelectActionConfirmModalController as vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                taiClass: getTaiClass(),
                windowClass: getWindowClass(),
                resolve: {
                    ctmsConfirmTime: function() {
                        return ctmsConfirmTime;
                    },
                    data: function() {
                        return param;
                    }
                }
            });
            return modalResult;
        }

        function openOptionSelector(data, title, isCycle) {
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/optionSelector.html',
                controller: 'optionSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: getTaiClass(),
                resolve: {
                    titleTranslate: function() {
                        return title;
                    },
                    keyValueList: function() {
                        return data;
                    },
                    isCycle: function() {
                        return isCycle;
                    }
                }

            });
            return result;
        }

    }
})();